import React from 'react';
import styles from "../styles/footer.css"; 
import footerLogo from "../images/logoo-removebg-preview.png";
import translations from "./translations";
import { useLanguage } from "./Context/LanguageContext";
const Footer = () => {
  const { language } = useLanguage();
  return (
    <footer className="main-footer-container">
      <div className="container footer-section">
        <div className="footer-item">
          <div className="footer-item-header">
            <a href="#" className="logo-img">
              <img src={footerLogo} alt="" className="mw-100" />
            </a>
          </div>
         
        </div>
    <div className='footer-group'>

        <div className="footer-item">
          <div className="footer-item-header">
            <h3>{translations[language].footertopic1}</h3>
            
          </div>
          <ul id="about">
            <li><a href=""> {translations[language].footersubtopic1}</a></li>
            <li><a href=""> {translations[language].footersubtopic2}</a></li>
            <li><a href=""> {translations[language].footersubtopic3} </a></li>
          </ul>
        </div>
        <div className="footer-item">
          <div className="footer-item-header">
            <h3>{translations[language].footertopic2}</h3>
            
          </div>
          <ul id="about">
            <li><a href="https://www.facebook.com/profile.php?id=61550614966784"><i className="fa-brands fa-facebook-f"></i> {translations[language].footerfacebook}</a></li>
            <li><a href="https://www.linkedin.com/in/cairomed-417802290/"> <i className="fa-brands fa-linkedin"></i>{translations[language].footerlinkedin}</a></li>
            <li><a href="https://wa.me/201001110621"> <i className="fa-brands fa-whatsapp"></i> {translations[language].footerwhatsapp} </a></li>
           
          </ul>
        </div>
    </div>
      </div>

      <div className="footer-copyright-container">
        <div className="footer-copyright-container-centered">
          <div>
            <p>{translations[language].footercopyright} <a href="https://www.linkedin.com/in/mohamed-wanas-a3a41723b/">{translations[language].footerdev1}</a>  <a href="https://www.linkedin.com/in/mohamed-abusaif-050/">{translations[language].footerdev2}</a> <a href="https://www.linkedin.com/in/eman-abdullah-082b75367/">{translations[language].footerdev3}</a></p>
          </div>
          <div>
            <a href="">{translations[language].formPrivacyPolicy}</a>
            <a href=""> {translations[language].formTermsAndConditions}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
